import React, { useState } from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { useToast } from '../../../controller/ToastController';
import HotelController, {
  roomAssignmentNotificationListType,
} from '../../../controller/HotelController';
import ConfirmModal from '../../../components/modal/ConfirmModal';

const HotelNoticeReservationList = ({
  notificationList,
  getRoomNotificationList,
  checkoutType,
}: {
  notificationList: any;
  getRoomNotificationList: any;
  checkoutType: number;
}) => {
  const showToast = useToast();
  const [noticeDetailId, setNoticeDetailId] = useState<number | null>(null);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const deleteClick = (noticeDetailId: number) => {
    setNoticeDetailId(noticeDetailId);
    setVisibleConfirm(true);
  };
  const confirmDelete = () => {
    if (noticeDetailId !== null) {
      delAlert(noticeDetailId);
    }
    setVisibleConfirm(false);
  };
  const delAlert = async (gradeId: number) => {
    try {
      const oParams = {
        notice_detail_id: gradeId,
      };
      const oRes: any = await HotelController.delAlert(oParams);

      if (oRes && oRes.data.ok) {
        showToast('삭제되었습니다.');
        getRoomNotificationList();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  return (
    <Style>
      <div className="reservationListBoxWrap">
        <div className="title">알림 예약 목록</div>
        {notificationList && notificationList.length > 0 ? (
          <>
            {notificationList?.map((data: roomAssignmentNotificationListType, index: number) => (
              <div key={index} className={` ${data.isSent ? 'dataList disabled' : 'dataList'}`}>
                <div className="listTop flex">
                  {checkoutType === 0 && <h3>매일 {data.noticeTime}</h3>}
                  {checkoutType === 1 && (
                    <>
                      <h3>{moment(data.noticeAt).format('YYYY/MM/DD')}</h3>
                      <h3>{moment(data.noticeAt).format('HH:mm')}</h3>
                    </>
                  )}
                  <h3>{data.areaNames.join(', ')}</h3>
                  {!data.isSent && (
                    <button
                      className="listButtonWrap"
                      onClick={() => deleteClick(data.noticeDetailId)}>
                      <img src={`${process.env.PUBLIC_URL}/svg/ic_delete.svg`} alt="삭제아이콘" />
                    </button>
                  )}
                </div>
                <div className="contentText">
                  <p>{data.content}</p>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="noneList">
            <p>예약된 알림이 없습니다.</p>
          </div>
        )}
      </div>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={confirmDelete}
      />
    </Style>
  );
};

export default HotelNoticeReservationList;

const Style = styled.div`
  h3 {
    font-size: 16px;
    font-weight: 400;
    color: #555;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    color: #979797;
  }

  .reservationListBoxWrap {
    border: 1px solid #cecece;
    border-radius: 5px;
    max-height: 350px;
    overflow-y: auto;

    .title {
      margin: 0;
      padding: 12px 30px;
      background: #ecf5f3;
      font-size: 18px;
      font-weight: 600;
      color: #555;
    }
    .dataList {
      padding: 20px 30px;
      border-top: 1px solid #cecece;
    }
    .disabled {
      background: #f7f7f7;
    }
    .contentText {
      color: #979797;
    }
  }
  .listTop {
    h3:nth-child(3) {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: 30px;
    }
    p {
      margin-top: 8px;
    }
  }
  .noneList p {
    text-align: center;
  }

  @media (max-width: 500px) {
    h3 {
      font-size: 12px;
    }
    .reservationListBoxWrap {
      .title {
        font-size: 16px;
        padding: 14px 20px;
      }
      .dataList {
        padding: 10px 20px;
      }
    }
  }
`;
